// extracted by mini-css-extract-plugin
export var carrierIcon = "_wd-0";
export var carrierLogo = "_wd-1";
export var detailsSection = "_wd-2";